/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import AddFaq from "./AddFaq.container";

export default AddFaq;
